import VamosComponent from "vamos/cockpit/Component";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import V4Context from "sap/ui/model/odata/v4/Context";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ResponseObject } from "vamos/cockpit/model/api/vamos.private.api.types";
import BaseService from "vamos/cockpit/base/services/BaseService";

export default class GoodsRecipientService extends BaseService{

    constructor(component:VamosComponent){
        super(component,"/GoodsRecipients");
    }

    async loadBySupplierGuid(supplierGuid:string):Promise<V4Context[]>{
        const filter:Filter = new Filter("SupplierGuid", FilterOperator.EQ, supplierGuid);
        const listBinding:ODataListBinding = this.getListBinding();
        listBinding.filter(filter);
        return await listBinding.requestContexts();
    }
    async callSetDefault(articleGuid:string, supplierGuid:string):Promise<void>{


    }
    async callGetDefaultForArticleAndSupplierGuid(articleGuid:string, supplierGuid:string):Promise<string>{
        const response:ResponseObject = await ApiService.getInstance().getRestJsonData(`/goods-recipient/default-for-article/${articleGuid}/${supplierGuid}`) as ResponseObject;
        return response.content as string;
    }


}